import React from 'react'
import { api } from '@api/index'
import AdminSidebar from '@components/admin/AdminSidebar'
import MessageModal from '@components/shared/MessageModal'
import useModal from '@hooks/useModal'
import { Message } from '@utils/message'
import { FieldValues, FormProvider, useForm } from 'react-hook-form'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { Link, useNavigate, useParams } from 'react-router-dom'
import AdminPostForm from '@components/admin/AdminPostForm'
import AdminPostReply from '@components/admin/AdminPostReply'
import 'twin.macro'
import AdminPostReplyForm from '@components/admin/AdminPostReplyForm'

const AdminPostDetailManagement = () => {
  const queryClient = useQueryClient()
  const { id: postUUID } = useParams()
  const [openResModal] = useModal()
  const navigate = useNavigate()

  const methods = useForm({
    mode: 'onChange',
  })

  const { setValue } = methods

  const _ = useQuery(
    ['PostDetail', postUUID],
    () => api.adminService.getPostDetail(Number(postUUID)),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        Object.entries(data).forEach(([key, value]) => {
          setValue(key, value)
        })
      },
    }
  )

  const {
    isLoading,
    error,
    data: replys,
  } = useQuery(
    ['PostReply', Number(postUUID)],
    () => api.adminService.getPostReply(Number(postUUID)),
    {
      refetchOnWindowFocus: false,
    }
  )

  const deletePostMutation = useMutation((postUUID: number) =>
    api.adminService.deletePost(postUUID)
  )

  const handleDeleteClick = async () => {
    const res = await openResModal(
      <MessageModal>{Message.question.DELETE_NOTICE}</MessageModal>
    )
    if (!res) return
    deletePostMutation.mutate(Number(postUUID), {
      onSuccess: async () => {
        await openResModal(
          <MessageModal>{Message.info.SUCCESS_DELETE_NOTICE}</MessageModal>
        )
        navigate('/admin/post-management')
      },
    })
  }

  const handleBackClick = () => {
    navigate(-1)
  }

  return (
    <FormProvider {...methods}>
      <section tw="w-1200 flex gap-32">
        <AdminSidebar />
        <main tw="w-full pb-100">
          <h1 tw="text-2xl border-b-2 font-bold pb-10 mb-20 border-neutral-400">
            게시글 상세
          </h1>
          <form>
            <div tw="w-full flex justify-end  gap-12">
              <button
                onClick={handleDeleteClick}
                form="user-modify-form"
                type="button"
                tw="py-4 px-20"
                className="button"
              >
                게시글 삭제
              </button>
              <button
                onClick={handleBackClick}
                type="button"
                tw="py-4 px-20"
                className="button"
              >
                뒤로가기
              </button>
            </div>
            <div tw="w-full px-2 py-3">
              <AdminPostForm readonly />
            </div>
          </form>
          {replys?.map((reply) => (
            <AdminPostReply
              key={reply.id}
              reply={reply}
              postUUID={Number(postUUID)}
            />
          ))}
          <AdminPostReplyForm postUUID={Number(postUUID)} />
        </main>
      </section>
    </FormProvider>
  )
}

export default AdminPostDetailManagement
